<template>
<div>
    <template v-for="(widget, widget_name) in widgets">
        <div :key="'widget_qid_'+qid+'_'+widget_name">
            <div v-if="debug">
                Widget Name: {{widget_name}}
                <hr>
                Display: {{display(widget_name)}}
                <hr>
                Widget: {{widget}}
                <hr>
                Triggers: {{triggers[widget_name]}}
                
            </div>
            <template v-if="widget && display(widget_name)"> 
                <component
                    :key="'qid_'+qid+'_'+widget_name"   
                    :is="widget_name"
                    :question="question"
                    :questionMap="questionMap"
                    :triggers="triggers[widget_name]"
                    :debug="debug"
                />
            </template>
        </div>
    </template>
</div>
</template>

<script>
import sample from './widgets/sample';
import KnowledgeTransfer from './widgets/KnowledgeTransfer.vue';

const tracker = require('./../../../lib/tracker.js')

export default {
    name: 'case-3-widgets',
    props: {
        question: {
            type: Object,
            required: true
        },
        questionMap: {
            type: Object,
            required: true
        },
        widgetRules: {
            type: Array,
            required: true
        },
        debug: {
            type: Boolean,
            required: false,
            default: false
        } 
    },
    components: {
        sample,
        KnowledgeTransfer
    },
    mixins: [ 
        tracker // contains methods and watch suplimetary functions
    ],             
    methods: {
        is_triggered: function(widget_name){
            var self = this;
            var output = {};
            let rules = this.widgets[widget_name];
            for(let r=0; r<rules.length; r++){
                let rule = rules[r];
                output[rule.name] = {};
                let conditions = rule.conditions;

                for(let c=0; c<conditions.length; c++){
                    let result = false;
                    let condition = conditions[c];

                    let ref_id = condition.ref_id;
                    let group_id = condition.group_id;
                    let question = (ref_id && group_id) ? this.questionMap[ref_id] : null;

                    let value = (question && question.value) ? question.value[condition.group_id] : null;
                    
                    if(value!=null){

                        if(condition.equals!=null){
                            result = typeof value=='object' ? this.$root.in_array(condition.equals, value) : condition.equals==value;
                        }

                        if(condition.contains!=null && condition.contains.length>0){
                            let contains = JSON.parse(condition.contains);
                            result = this.$root.in_array(value, contains);
                        }

                    }

                    if(typeof condition.advanced == 'function'){
                        try {
                            result = condition.advanced(question, self.questionMap, self.$language(), self);
                        } catch (error) {
                            console.error('WIDGET EXECUTION ERROR',{
                                widget_name: widget_name,
                                rule: rule.name,
                                error: error
                            })
                        }
                        output[rule.name][condition.name+'_advanced'] = result;
                    }

                    output[rule.name][condition.name] = result;
                }

            }
            return output;
        },
        display: function(widget_name, triggers=null){
            triggers = triggers===null ? this.triggers[widget_name] : triggers[widget_name];
            for(let rule_name in triggers){
                let conditions = triggers[rule_name];
                if(this.$root.allTrue(conditions)){
                    return true;
                    break;
                }
            }
            return false;            
        }
    },
    computed: {
        qid: function(){
            return this.question.config.id
        },
        widgets: function(){
            var widgets = {};
            for(let i=0; i<this.widgetRules.length; i++){
                var record = this.widgetRules[i];
                var isTarget = this.$root.in_array(this.qid, record.display_target);
                if(isTarget){
                    widgets[record.name] = record.rules;
                }
            }

            return widgets
        },
        triggers: function(){
            let output = {};
            for(let widget_name in this.widgets){
                output[widget_name] = this.is_triggered(widget_name);
            }
            
            return output;
        }
    }
}
</script>

<style>

</style>